import { INotification } from '@/services/Notification/notifications.types.ts'
import { HTTPResponse, IPaginationResponse } from '@/services/http/http.types.ts'
import http, { handleHttpError, handleHttpResponse } from '@/services/http'
import httpUtils from '@/services/http/http.utils.ts'

const setNotificationViewed = (notificationIds: INotification['id'][]): Promise<HTTPResponse<INotification>> => {
  return http
    .post('/nsi/v1/self/notifications/seen', { notificationIds })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const getPersonalisedNotifications = httpUtils.createAbortableRequest(
  (signal, params?: { pageToken: string }): Promise<HTTPResponse<IPaginationResponse<INotification>>> => {
    return http.get('/nsi/v1/self/notifications', { signal, params }).then(handleHttpResponse).catch(handleHttpError)
  }
)

const notificationsApi = { setNotificationViewed, getPersonalisedNotifications }
export default notificationsApi
